/* eslint-disable */
import { permissionsMessages } from '@ringcentral-integration/commons/enums/permissionsMessages';
export default {
  [permissionsMessages.invalidTier]:
    'A sua edição não suporta a integração do {application}. Contacte o representante da conta para atualizar a edição {brand}.',
  [permissionsMessages.insufficientPrivilege]:
    'Privilégio insuficiente. Contacte o representante da conta para obter uma atualização.',
} as const;

// @key: @#@"[permissionsMessages.invalidTier]"@#@ @source: @#@"Your edition does not support {application} integration. Please contact your account representative to upgrade your {brand} edition."@#@
// @key: @#@"[permissionsMessages.insufficientPrivilege]"@#@ @source: @#@"Insufficient privilege. Please contact your account representative for an upgrade."@#@
